import {
    GETINQUIRY_SUCCESS,
    GETINQUIRY_FAILED,
    RESET_GETINQUIRY,
    LOADING_GETINQUIRY,
    NETWORK_ERROR_GETINQUIRY,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {

    switch (action.type) {
        case LOADING_GETINQUIRY:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETINQUIRY_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETINQUIRY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETINQUIRY:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETINQUIRY:
            return (state = initialState);
        default:
            return state;
    }
};
